/* The Bhakti Centre booking: shared helpers and the class page date picker.
   The calendar lives in bhakti-calendar.js and needs this file loaded first. */
(function () {
  'use strict';
  if (window.BhaktiBooking) { window.BhaktiBooking.scan(); return; }

  var TZ = 'Europe/London';
  var DAY_MS = 86400000;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var WD = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  var CAT_LABEL = { kirtan: 'Kirtan', yoga: 'Yoga', masterclass: 'Masterclass', meditation: 'Meditation', event: 'Event', class: 'Class' };
  var FILTERS = [['all', 'Everything'], ['kirtan', 'Kirtan'], ['yoga', 'Yoga'], ['meditation', 'Meditation'], ['event', 'Events']];
  var ICON_X = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  function dtf(o) { o.timeZone = TZ; return new Intl.DateTimeFormat('en-GB', o); }
  var F = {
    short: dtf({ weekday: 'short', day: 'numeric', month: 'short' }),
    long: dtf({ weekday: 'long', day: 'numeric', month: 'long' }),
    key: dtf({ year: 'numeric', month: '2-digit', day: '2-digit' }),
    time: dtf({ hour: 'numeric', minute: '2-digit', hour12: true })
  };
  function parts(f, d) { var o = {}; f.formatToParts(d).forEach(function (p) { o[p.type] = p.value; }); return o; }
  function timeStr(d) {
    var p = parts(F.time, d);
    var ap = (p.dayPeriod || '').toLowerCase().replace(/[^ap]/g, '') + 'm';
    return p.hour + (p.minute === '00' ? '' : '.' + p.minute) + ap;
  }
  function timeRange(s) { return timeStr(s.start) + (s.end ? ' to ' + timeStr(s.end) : ''); }
  function dayKey(d) { var p = parts(F.key, d); return p.year + '-' + p.month + '-' + p.day; }
  function monthName(d) { var k = dayKey(d); return MONTHS[Number(k.slice(5, 7)) - 1] + ' ' + k.slice(0, 4); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function money(p) { return '£' + (p % 100 ? (p / 100).toFixed(2) : String(p / 100)); }
  function plural(n, w) { return n + ' ' + w + (n === 1 ? '' : 's'); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function spacesText(s) { return s.full ? 'Full' : (s.left === Infinity ? '' : plural(s.left, 'space') + ' left'); }

  function load(root, windowDays) {
    var el = root.querySelector('[data-bk-data]');
    var raw = [];
    try { raw = JSON.parse(el ? el.textContent : '[]'); } catch (e) { raw = []; }
    var flat = [];
    raw.forEach(function (x) { if (Array.isArray(x)) flat = flat.concat(x); else if (x) flat.push(x); });
    var now = Date.now(), end = now + windowDays * DAY_MS;
    return flat.map(function (s) {
      var left = (s.q === null || s.q === undefined) ? (s.a ? Infinity : 0) : Math.max(0, Number(s.q));
      var cat = s.c || 'class';
      if (s.n && cat === 'yoga') cat = 'masterclass';
      var start = new Date(Number(s.s) * 1000);
      var end = s.e ? new Date(Number(s.e) * 1000) : (Number(s.m) > 0 ? new Date(start.getTime() + Number(s.m) * 60000) : null);
      return {
        id: String(s.v), product: s.p, label: s.l || s.p, title: s.t || s.l || s.p, note: s.n || '', url: s.u, cat: cat,
        start: start, end: end, diet: s.d === true, price: Number(s.pr), left: left, full: left <= 0
      };
    }).filter(function (s) {
      var t = s.start.getTime();
      return !isNaN(t) && t >= now && t <= end;
    }).sort(function (a, b) { return a.start - b.start; });
  }

  function refreshBubble() {
    fetch(ROOT + '?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
      var target = document.getElementById('cart-icon-bubble');
      if (!target || !s['cart-icon-bubble']) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = s['cart-icon-bubble'];
      var inner = tmp.querySelector('.shopify-section');
      target.innerHTML = inner ? inner.innerHTML : tmp.innerHTML;
    }).catch(function () {});
  }

  function addToCart(items) {
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Sorry, we could not add that to your basket.');
        refreshBubble();
        return j;
      });
    });
  }

  var DIET_KEY = 'Allergies or dietary needs';
  function dietField(id) {
    return '<label class="bk-diet" for="' + id + '"><span>' + DIET_KEY + ' (optional)</span>' +
      '<input type="text" id="' + id + '" data-bk-diet maxlength="200" autocomplete="off"></label>';
  }
  function withDiet(items, value) {
    var v = (value || '').trim();
    if (!v) return items;
    return items.map(function (it) { var p = {}; p[DIET_KEY] = v; it.properties = p; return it; });
  }

  function stepper(q, max, label) {
    return '<div class="bk-qty"><span class="bk-qty__label">' + label + '</span>' +
      '<button type="button" class="bk-step" data-act="dec" aria-label="One fewer ticket"' + (q <= 1 ? ' disabled' : '') + '>&minus;</button>' +
      '<span class="bk-qty__n" aria-live="polite">' + q + '</span>' +
      '<button type="button" class="bk-step" data-act="inc" aria-label="One more ticket"' + (q >= max ? ' disabled' : '') + '>+</button></div>';
  }

  /* ---------- Class page date picker ---------- */
  function initProduct(root) {
    if (root.dataset.bkReady) return;
    root.dataset.bkReady = '1';
    var win = Number(root.dataset.bkWindow) || 61;
    var sessions = load(root, win);
    var byId = {};
    sessions.forEach(function (s) { byId[s.id] = s; });
    var list = root.querySelector('[data-bk-list]');
    var bar = root.querySelector('[data-bk-bar]');
    var sum = root.querySelector('[data-bk-summary]');
    var btn = root.querySelector('[data-bk-add]');
    var msg = root.querySelector('[data-bk-msg]');
    var toggle = root.querySelector('[data-bk-toggle]');
    var drop = root.querySelector('[data-bk-drop]');
    var next = root.querySelector('[data-bk-next]');
    var sel = {};

    if (!sessions.length) {
      if (toggle) toggle.hidden = true;
      if (drop) drop.hidden = true;
      if (next) next.textContent = 'No dates are open for booking just now. New dates are added regularly, so please check back soon.';
      return;
    }

    var open = sessions.filter(function (s) { return !s.full; });
    if (next) {
      if (open.length) {
        var low = Math.min.apply(null, open.map(function (s) { return s.price; }));
        var high = Math.max.apply(null, open.map(function (s) { return s.price; }));
        next.textContent = 'Next date: ' + F.short.format(open[0].start) + ', ' + timeStr(open[0].start) +
          ', ' + (low === high ? money(low) : 'from ' + money(low));
      } else {
        next.textContent = 'All current dates are full. New dates are added regularly.';
      }
    }
    function setOpen(on) {
      if (!toggle || !drop) return;
      drop.hidden = !on;
      toggle.setAttribute('aria-expanded', String(on));
      var label = toggle.querySelector('[data-bk-toggle-label]');
      if (label) label.textContent = on ? 'Hide dates' : 'Book now';
    }
    if (toggle) {
      toggle.addEventListener('click', function () { setOpen(drop.hidden); });
      setOpen(root.dataset.bkOpen === 'true');
    }
    var dietInput = null;
    if (sessions.some(function (s) { return s.diet; }) && bar) {
      var wrap = document.createElement('div');
      wrap.innerHTML = dietField('bk-diet-' + Math.random().toString(36).slice(2, 8));
      bar.insertBefore(wrap.firstChild, btn);
      dietInput = bar.querySelector('[data-bk-diet]');
    }

    function summary() {
      var d = 0, t = 0, total = 0;
      Object.keys(sel).forEach(function (id) { d++; t += sel[id]; total += sel[id] * byId[id].price; });
      sum.textContent = d ? plural(d, 'date') + ', ' + plural(t, 'ticket') + ', ' + money(total) : 'Choose one or more dates above';
      btn.disabled = !d;
    }

    function render(focus) {
      var html = '', month = '';
      sessions.forEach(function (s) {
        var m = monthName(s.start);
        if (m !== month) { html += (month ? '</div>' : '') + '<h3 class="bk-month">' + esc(m) + '</h3><div class="bk-rows">'; month = m; }
        var q = sel[s.id] || 0, on = q > 0;
        var meta = s.full ? 'Full' : money(s.price) + (s.left === Infinity ? '' : ', ' + spacesText(s));
        html += '<div class="bk-row bk-c-' + esc(s.cat) + (on ? ' is-on' : '') + (s.full ? ' is-full' : '') + '" data-id="' + esc(s.id) + '">' +
          '<button type="button" class="bk-pick" data-act="toggle" aria-pressed="' + on + '"' + (s.full ? ' disabled' : '') + '>' +
          '<span class="bk-tick" aria-hidden="true"></span>' +
          '<span class="bk-when"><span class="bk-date">' + esc(F.short.format(s.start)) + '</span>' +
          '<span class="bk-time">' + esc(timeRange(s)) + '</span>' +
          (s.note ? '<span class="bk-note">' + esc(s.note) + '</span>' : '') + '</span>' +
          '<span class="bk-meta">' + esc(meta) + '</span></button>' +
          (on ? stepper(q, s.left, 'Tickets') : '') + '</div>';
      });
      list.innerHTML = html + '</div>';
      summary();
      if (focus) {
        var el = list.querySelector('.bk-row[data-id="' + focus.id + '"] [data-act="' + focus.act + '"]') ||
          list.querySelector('.bk-row[data-id="' + focus.id + '"] [data-act="toggle"]');
        if (el) el.focus();
      }
    }

    list.addEventListener('click', function (e) {
      var b = e.target.closest('[data-act]');
      var row = e.target.closest('.bk-row');
      if (!b || !row) return;
      var id = row.dataset.id, s = byId[id], a = b.dataset.act;
      if (!s || s.full) return;
      if (a === 'toggle') { if (sel[id]) delete sel[id]; else sel[id] = 1; }
      else if (a === 'inc' && sel[id] < s.left) sel[id]++;
      else if (a === 'dec') { if (sel[id] > 1) sel[id]--; else delete sel[id]; }
      msg.textContent = '';
      render({ id: id, act: a });
    });

    btn.addEventListener('click', function () {
      var ids = Object.keys(sel);
      if (!ids.length) return;
      var items = withDiet(ids.map(function (id) { return { id: Number(id), quantity: sel[id] }; }), dietInput && dietInput.value);
      btn.disabled = true;
      msg.textContent = 'Adding to your basket';
      addToCart(items).then(function () {
        ids.forEach(function (id) {
          var s = byId[id];
          if (s.left !== Infinity) { s.left -= sel[id]; s.full = s.left <= 0; }
        });
        sel = {};
        render();
        msg.innerHTML = 'Added to your basket. <a href="' + ROOT + 'cart">View basket and check out</a>';
      }).catch(function (err) {
        msg.textContent = err.message;
        summary();
      });
    });

    render();
  }

  function scan() {
    document.querySelectorAll('[data-bk-product]').forEach(initProduct);
    if (window.BhaktiCalendar) window.BhaktiCalendar.scan();
  }
  window.BhaktiBooking = {
    scan: scan,
    u: { DAY_MS: DAY_MS, ROOT: ROOT, MONTHS: MONTHS, WD: WD, CAT_LABEL: CAT_LABEL, FILTERS: FILTERS, ICON_X: ICON_X, F: F,
      timeStr: timeStr, timeRange: timeRange, dayKey: dayKey, pad: pad, money: money, esc: esc, spacesText: spacesText,
      load: load, addToCart: addToCart, stepper: stepper, dietField: dietField, withDiet: withDiet }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();